// Certificate.tsx
import { memo } from "react";

interface CertificateProps {
  title: string;
  studentName: string;
  percentage: number;
}

export const Certificate = memo(({ title, studentName, percentage }: CertificateProps) => (
  <div className="border-[10px] border-double rounded-3xl p-10 bg-gradient-to-br from-yellow-50 to-white mb-8 print:shadow-none">
    <div className="text-center">
      <p className="uppercase tracking-[0.3em] text-sm text-gray-500 mb-4">Certificate of Completion</p>
      <h2 className="text-5xl font-bold mb-6">🏆</h2>
      <p className="text-lg mb-2">This certificate is proudly presented to</p>
      <h1 className="text-4xl font-bold mb-6">{studentName}</h1>
      <p className="text-lg leading-relaxed max-w-2xl mx-auto">for successfully completing the quiz:</p>
      <h3 className="text-2xl font-semibold mt-4 mb-6">{title}</h3>
      
      <div className="flex justify-center gap-10 flex-wrap mt-10">
        <CertificateDetail label="Final Score" value={`${percentage}%`} />
        <CertificateDetail label="Date" value={new Date().toLocaleDateString()} />
      </div>
    </div>
  </div>
));

const CertificateDetail = ({ label, value }: { label: string; value: string }) => (
  <div>
    <p className="text-sm text-gray-500">{label}</p>
    <p className="font-bold text-xl">{value}</p>
  </div>
);

Certificate.displayName = "Certificate";